import styled from '@emotion/styled';
import { Tag } from 'antd';

export const StyledTag = styled(Tag)`
  margin-right: 0;
`;
